import axiosInstance from "../utils/axiosInstance";

const fetchFormsApi = url => axiosInstance.get(url).then(response => response);

export default fetchFormsApi;
